// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
export const SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY = 'search-personalization-site-user';
export const SEVEN_DAY_MS_TTL: number = 1000 * 7 * 24 * 60 * 60; // 7 days
export const ONE_DAY_MS_TTL: number = 1000 * 24 * 60 * 60; // 1 day
export const ONE_HOUR_MS_TTL: number = 1000 * 60 * 60; // 1 hour
export const RIGHT_PANEL_TRAIT = 'search_user_3p_recommendations_right_panel_v1';

// Smartlink Product Usage
export const SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY =
	'search-personalization-smartlink-site';
export const SMARTLINK_APP_EXPOSURE_RATE_TRAIT = 'smartlink_app_exposure_rate';

// Smartlink Usage and Top Apps (site-scoped TAP trait)
export const SEARCH_PERSONALIZATION_SMARTLINK_USAGE_AND_TOP_APPS_SITE_CACHE_KEY =
	'search-personalization-smartlink-usage-and-top-apps-site';
export const SMARTLINK_USAGE_AND_TOP_APPS_TRAIT =
	'rovo_nudge_end_user_rendered_smartlinks_percent_and_most_used_apps';
